import Page from "../../components/PrivacyPolicy/Page";

const sections = [
  {
    heading: "Interpretation and Definition",
    content: [
      { type: "subheading", value: "Interpretation" },
      {
        type: "content",
        value:
          "We collect information about you in a range of ways including when you provide information directly to us, when you visit our website, and when you provide information to us through third parties. We may collect, store and use the following kinds of personal information",
      },
      { type: "subheading", value: "Definition" },
      {
        type: "content",
        value:
          "We collect information about you in a range of ways including when you provide information directly to us, when you visit our website, and when you provide information to us through third parties. We may collect, store and use the following kinds of personal information",
      },
    ],
  },
  {
    heading: "Information we Collect",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "User Generated Content",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Sensitive Information",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Disclosure of personal information to third parties",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Your rights and controlling your personal information",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Business Transfers",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Children's Policy",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Limit to Our Policy",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Sensitive Information",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Additional Disclosures for Califonia Compliance (US)",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Severability and Waiver",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
  {
    heading: "Contact Us",
    content: [
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
      {
        type: "content",
        value:
          "We may provide you with the opportunity to share information through our Services, like through social media plugins or other integrated tools. The sharing of this information is subject to the privacy policies of the third party websites.",
      },
    ],
  },
];

const PrivacyPolicy: React.FC = () => {
  return <Page pageTitle="Privacy Policy" sections={sections} />;
};

export default PrivacyPolicy;
